module.exports = __webpack_public_path__ + "static/media/vallensbaek_map.4669c40c.png";